var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataHubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icons",
    d: "M15.625 3.66406L10.625 7.66406C10.25 7.97656 9.75 7.97656 9.375 7.69531L6 5.16406L1.625 8.66406C1.1875 9.00781 0.5625 8.94531 0.21875 8.50781C-0.125 8.10156 -0.0625 7.44531 0.375 7.10156L5.375 3.10156C5.71875 2.82031 6.21875 2.82031 6.59375 3.10156L9.96875 5.63281L14.375 2.10156C14.7812 1.75781 15.4375 1.85156 15.7812 2.25781C16.125 2.69531 16.0312 3.32031 15.625 3.66406ZM5 8.88281C5 8.35156 5.4375 7.88281 6 7.88281C6.53125 7.88281 7 8.35156 7 8.88281V14.8828C7 15.4453 6.53125 15.8828 6 15.8828C5.4375 15.8828 5 15.4453 5 14.8828V8.88281ZM1 11.8828C1 11.3516 1.4375 10.8828 2 10.8828C2.53125 10.8828 3 11.3516 3 11.8828V14.8828C3 15.4453 2.53125 15.8828 2 15.8828C1.4375 15.8828 1 15.4453 1 14.8828V11.8828ZM10 9.88281C10.5312 9.88281 11 10.3516 11 10.8828V14.8828C11 15.4453 10.5312 15.8828 10 15.8828C9.4375 15.8828 9 15.4453 9 14.8828V10.8828C9 10.3516 9.4375 9.88281 10 9.88281ZM13 8.88281C13 8.35156 13.4375 7.88281 14 7.88281C14.5312 7.88281 15 8.35156 15 8.88281V14.8828C15 15.4453 14.5312 15.8828 14 15.8828C13.4375 15.8828 13 15.4453 13 14.8828V8.88281Z",
    fill: "#015294"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataHubIcon);
export default __webpack_public_path__ + "static/media/dataHub-icon.92c8a7c98f300975a0f995e74ab3eb6d.svg";
export { ForwardRef as ReactComponent };